<form
	[formGroup]="formGroup"
	[ngClass]="{'mt-5': addSpaceToPrevious}"
>
	<div
		class="mb-3 formElementWrapper"
		(mouseover)="setHovered( true )"
		(mouseout)="setHovered( false )"
	>

		<app-form-datepicker
			[formEntityId]="formEntityIdFrom"
			[config]="configFrom"
			[formGroup]="formGroup"
			[hideErrors]="hideErrors"
			[hideErrorDescriptions]="hideErrorDescriptions"
			[readOnly]="readOnly"
			[isRequired]="isRequired"
			[formControlInline]="formControlInline"
			[labelInfoInline]="labelInfoInline"
			[disableControl]="disableControl"
			[labelText]="labelText"
			[datepickerPopupPlacement]="datepickerFromPopupPlacement"
			[colSpan]="colSpan"
			(changeEventEmitter)="onValueChanged($event, formEntityIdFrom)"
		></app-form-datepicker>

		<app-form-datepicker
			[formEntityId]="formEntityIdTo"
			[config]="configTo"
			[formGroup]="formGroup"
			[hideErrors]="hideErrors"
			[hideErrorDescriptions]="hideErrorDescriptions"
			[readOnly]="readOnly"
			[isRequired]="isRequired"
			[formControlInline]="formControlInline"
			[labelInfoInline]="labelInfoInline"
			[disableControl]="disableControl"
			[minDate]="toDateMinimum"
			[labelText]="labelText"
			[datepickerPopupPlacement]="datepickerToPopupPlacement"
			[colSpan]="colSpan"
			(changeEventEmitter)="onValueChanged($event, formEntityIdTo)"
		></app-form-datepicker>
	</div>
</form>
